import { geozonesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("geozone"),
  endpoint: "geozones",
  operations: geozonesOps,
  listEndpoint: "geozones",
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("Geozone"),
  name: (t) => t("Geozones"),
  syncCustomerFilter: true,
});

export default conf;
